import { render, staticRenderFns } from "./GDN.vue?vue&type=template&id=6aa79bc2&"
import script from "./GDN.vue?vue&type=script&lang=js&"
export * from "./GDN.vue?vue&type=script&lang=js&"
import style0 from "./GDN.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports